import styles from "./styles.module.css";

export const Success = (): JSX.Element => (
  <div className={styles.container}>
    <img src="/images/logo.png" alt="Urbano NOrte" />
    <h1>Agradecemos seu interesse em ser um licenciado Urbano Norte.</h1>
    <h3>Seu perfil será analisado e em breve entraremos em contato.</h3>
  </div>
);
